import { createContext, useContext, useState, ReactNode } from "react";

export interface AppUIContextType {
  // Shared search query across pages
  searchQuery: string;
  setSearchQuery: (q: string) => void;
}

const AppUIContext = createContext<AppUIContextType | undefined>(undefined);

export function AppUIProvider({ children }: { children: ReactNode }) {
  // Shared search query across pages
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <AppUIContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
      }}
    >
      {children}
    </AppUIContext.Provider>
  );
}

export function useAppUI() {
  const context = useContext(AppUIContext);
  if (!context) {
    throw new Error("useAppUI must be used within AppUIProvider");
  }
  return context;
}
